import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { CircularProgress } from './CircularProgress';
import { GridContainer } from './GridContainer';

export const Loading: React.FC = () => (
  <GridContainer>
    <Grid item xs={12} style={{ textAlign: 'center' }}>
      <CircularProgress />
    </Grid>
  </GridContainer>
);
